import { createContext } from "react";

export default createContext(null);
export const CN = 'cn'
export const EN = 'en'
